module.exports = __webpack_public_path__ + "img/bg-bsqg.94855fd6.png";